function PowerBISTX() {
  let user = localStorage.getItem("Username");

  return (
    <>
      {localStorage.getItem("Username") === "curtis@investin.org" ||
      localStorage.getItem("Username") === "rebecca@investin.org" ||
      user === "hitesh@investin.org" ||
      user === "shameer@investin.org" ||
      localStorage.getItem("Username") === "amy@investin.org" ||
      localStorage.getItem("Username") === "katherine.tarren@investin.org" ? (
        <div style={{ width: "90%", height: "90%" }}>
          <iframe
            title="STX"
            style={{ width: "100%", height: "100%" }}
            src="https://app.powerbi.com/reportEmbed?reportId=2718e0f9-d7e7-4ed8-a02a-b70798726906&autoAuth=true&ctid=5fb461ed-7397-4bdd-9dc6-5db63180bbb1"
            frameborder="0"
            allowFullScreen="true"
          ></iframe>
        </div>
      ) : (
        <> </>
      )}
      <br></br> <br></br>
      {user === "curtis@investin.org" || user === "arsbi@investin.org" ? (
        <div style={{ width: "90%", height: "90%" }}>
          <iframe
            title="STX Arsbi"
            style={{ width: "100%", height: "100%" }}
            src="https://app.powerbi.com/reportEmbed?reportId=6f07a2c6-ab2b-42d7-bb2d-627fb4608ee5&autoAuth=true&ctid=5fb461ed-7397-4bdd-9dc6-5db63180bbb1"
            frameborder="0"
            allowFullScreen="true"
          ></iframe>
        </div>
      ) : (
        <></>
      )}{" "}
      <br></br> <br></br>
      {user === "curtis@investin.org" ||
      user === "rebeccaseymour@investin.org" ? (
        <div style={{ width: "90%", height: "90%" }}>
          <iframe
            title="STX Becca"
            style={{ width: "100%", height: "100%" }}
            src="https://app.powerbi.com/reportEmbed?reportId=5e3dc7e8-c1c7-4c6e-a730-23960941745c&autoAuth=true&ctid=5fb461ed-7397-4bdd-9dc6-5db63180bbb1"
            frameborder="0"
            allowFullScreen="true"
          ></iframe>
        </div>
      ) : (
        <></>
      )}{" "}
      <br></br> <br></br>
      {user === "curtis@investin.org" || user === "molly@investin.org" ? (
        <div style={{ width: "90%", height: "90%" }}>
          <iframe
            title="STX Molly"
            style={{ width: "100%", height: "100%" }}
            src="https://app.powerbi.com/reportEmbed?reportId=cba7cdea-1439-4b0f-81f9-05241809ee26&autoAuth=true&ctid=5fb461ed-7397-4bdd-9dc6-5db63180bbb1"
            frameborder="0"
            allowFullScreen="true"
          ></iframe>
        </div>
      ) : (
        <> </>
      )}{" "}
      <br></br> <br></br>
      {user === "curtis@investin.org" || user === "aaliyah@investin.org" ? (
        <div style={{ width: "90%", height: "90%" }}>
          <iframe
            title="STX Aaliyah"
            style={{ width: "100%", height: "100%" }}
            src="https://app.powerbi.com/reportEmbed?reportId=e36257e3-7982-4d06-ae8d-8e3a193c552e&autoAuth=true&ctid=5fb461ed-7397-4bdd-9dc6-5db63180bbb1"
            frameborder="0"
            allowFullScreen="true"
          ></iframe>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}

export default PowerBISTX;
